/**
 * The single place a real supabase-js client is constructed.
 *
 * Everything else takes a client (or a wrapper built on one) as an argument —
 * the UI imports createAuth(), never createClient(). That keeps the
 * "UI never talks to Supabase directly" rule (docs/ARCHITECTURE.md)
 * enforceable by grep: `@supabase/supabase-js` may appear in this file only.
 *
 * Session persistence: supabase-js stores the session in localStorage and
 * auto-refreshes the token in the background. localStorage — not our
 * IndexedDB — is a deliberate exception to ADR 0007: tokens are the
 * library's own small, string-shaped state with battle-tested handling of
 * refresh races across tabs; reimplementing that on IndexedDB buys risk and
 * nothing else. App DATA stays in IndexedDB.
 */
import { createClient } from '@supabase/supabase-js';
import { SUPABASE_ANON_KEY, SUPABASE_URL } from './supabase-config.js';

let client = null;

/** Lazily construct the shared client (one per page). */
export function getSupabase() {
  if (!client) {
    client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        // No OAuth redirects in the email-code flow, so no URL detection —
        // and leaving it on would make every app boot scan location.hash.
        detectSessionInUrl: false,
      },
      db: { schema: 'sketch' },
    });
  }
  return client;
}
